import "./index.scss";
import loaderIcon from "assets/loader.svg";


const Spinner = ({ size }: {size?: 'small' | 'medium' | 'large'}) => {
    return (
        <div id="qb-spinner" className="d-flex d-flex-column d-flex-center">
            <img alt="" src={loaderIcon} data-size={size} />
        </div>
    );
}

export default Spinner;